import { categoryIntro } from "@/mocks/melonData";

const catMeta = [
  {
    key: "follow",
    title: "后续跟进",
    num: "826 篇",
    desc: "事件发生后别急着下结论。我们持续补充后续动态，让故事在时间线上自然展开。",
  },
  {
    key: "reverse",
    title: "反转疑云",
    num: "214 篇",
    desc: "最刺激的是剧情急转直下。汇总每一次反转的关键证据，还原事情的来龙去脉。",
  },
  {
    key: "progress",
    title: "最新进展",
    num: "1,041 篇",
    desc: "消息分秒在变。这里集中呈现一颗瓜从发酵到落地的每一阶段最新进展。",
  },
  {
    key: "result",
    title: "实锤结果",
    num: "386 篇",
    desc: "尘埃落定的才算数。只有官方确认或一手证据坐实的，才归入结果栏目。",
  },
];

export default function CategoryField() {
  return (
    <section id="category" className="bg-accent-100/40 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-accent-700">
              <i className="ri-grid-fill" /> 分类瓜田
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">四种姿势，追清一颗瓜</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              后续、反转、进展、结果，四类划分让信息不再一锅乱炖。你关心的瓜处在哪个阶段，一目了然。
            </p>
          </div>
          <a
            href="#feed"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-lg border border-accent-200 bg-background-50 px-5 py-2.5 text-sm font-medium text-accent-800 hover:bg-background-100 transition-colors"
          >
            前往跟进列表
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {catMeta.map((c) => {
            const intro = categoryIntro[c.key as keyof typeof categoryIntro];
            return (
              <article
                key={c.key}
                className="group rounded-2xl border border-background-200/70 bg-background-50 p-6 hover:border-accent-200 transition-colors"
              >
                <div className={`inline-flex h-12 w-12 items-center justify-center rounded-xl ${intro.bg} ${intro.color}`}>
                  <i className={`${intro.icon} text-2xl`} />
                </div>
                <h3 className="mt-5 text-lg font-bold text-foreground-950">{c.title}</h3>
                <p className="mt-1 text-sm font-semibold text-primary-500">{c.num}</p>
                <p className="mt-3 text-sm leading-6 text-foreground-600">{c.desc}</p>
                <a
                  href="#feed"
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-accent-700 hover:text-accent-800"
                >
                  浏览栏目
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}